var controller = null;
var scene = null;
var tl = null;
var mobileWidth = 780;
var state = null;//'desktop';
var currentStep = 1;
var touchMove = false;

var Home = class Home {
    constructor() {
        this.initButtons();
    }

    animateIn () {
        window.scrollTo(0,0);

        // window.onbeforeunload = function () {
        //     window.scrollTo(0, 0);
        // };

        setAnimating(true);
        tl = new TimelineMax({onComplete: function () {
            setAnimating(false);
        }});

        var start = 0;

        tl
            .set("#header_01", {zIndex: 3, opacity: 1})

            .fromTo("#header_01" + " .img", 0.5, {x: "120%"}, {x: "0%"}, start)
            .from("#header_01" + " h1", 0.3, {y: -200, opacity: 0}, start + 0.4)
            .from("#header_01" + " .text", 0.3, {x: "-100%"}, start + .6)
            .from("#header_01" + " .number", 0.2, {x: -250}, start + .8)
            .from("#scroll_down", 1, {bottom: '+=100', opacity: 0, ease:Bounce.easeOut },start + .8)
            .from("#indicator, #view-the-looks", 0.3, {opacity: 0 }, start + .8)
        ;
        ;
        // TweenMax.from("#scroll_down", 1, {
        //      //x: '-=50', // Tween to the current x value minus 50
        //      marginBottom: '+=240', // Tween to the current y value plus 50
        //      ease:Elastic.easeOut.config(1, 0.3)
        //  });
    }

    setScene (){
        if($('#slideContainer').length == 0)
            return;

        if(window.innerWidth < mobileWidth){
            if(state == 'desktop'){
                window.location = window.location;
            }
            if(state != 'mobile'){
                this.destroyScrollMagic();
                this.initScrollMagicMobile();
                //initScrollMagicCollection();

            }
            state = 'mobile';
        }else{
            if(state == 'mobile'){
                window.location = window.location;
            }
            if(state != 'desktop'){
                this.destroyScrollMagic();
                this.initScrollMagic();
                this.initSmoothScroll();
            }
            state = 'desktop';
        }
    }


    initSmoothScroll(){
        var self = this;

        /*
        TOUCH
         */
        var touchStart = 0;
        var touchCurrentStep = 1;

        $(window).on('touchstart', function() {
            touchStart = $window.scrollTop();
            console.log(touchStart);
            touchMove = true;
        });
        $(window).on('touchend', function() {
            var touchEnd = $window.scrollTop();
            console.log(touchEnd);

            var delta = touchStart - touchEnd;

            if(delta > 0){
                console.log('go2');

                if(touchCurrentStep > 1){
                    self.scrollToStep(touchCurrentStep - 1);
                    touchCurrentStep -= 1;
                    return;
                }

            }else{
                console.log('go3');
                console.log(touchCurrentStep);

                if(touchCurrentStep < 5){
                    self.scrollToStep(touchCurrentStep + 1);
                    touchCurrentStep += 1;
                    return;
                }

            }
        });


        if (window.addEventListener) window.addEventListener('DOMMouseScroll', wheel, false);
        window.onmousewheel = document.onmousewheel = wheel;


        // ignore scroll when on scrollable element
        $('ul.stores').on('mousewheel', function(e){
            e.stopPropagation();
        });

        function wheel(event) {
            if(window.isAnimating){
                if (event.preventDefault) event.preventDefault();
                event.returnValue = false;
                return;
            }

            var delta = 0;
            if (event.wheelDelta) delta = event.wheelDelta / 120;
            else if (event.detail) delta = -event.detail / 3;

            //

            handleSnapScroll(delta);
            //return;

            if (event.preventDefault) event.preventDefault();
            event.returnValue = false;
        }

        var goUp = true;
        var end = null;
        var interval = null;

        function handleSnapScroll(delta){
            var scrollPosition = $window.scrollTop();
            var section_header_height = $('.scrollmagic-pin-spacer').eq(0).innerHeight();



            if(scrollPosition < (section_header_height * (2/3) ) ){
                console.log('go');

                if(delta > 0){
                    if(window.currentStep > 1){
                        self.scrollToStep(window.currentStep - 1);
                        return;
                    }

                }else{
                    if(window.currentStep < 4){
                        self.scrollToStep(window.currentStep + 1);
                        return;
                    }

                }
            }else{
                handle(delta);
            }

        }

        function handle(delta) {
            var animationInterval = 10; //lower is faster
            var scrollSpeed = 10; //lower is faster

            if (end == null) {
                end = $(window).scrollTop();
            }
            end -= 20 * delta;
            goUp = delta > 0;

            if (interval == null) {
                interval = setInterval(function () {
                    var scrollTop = $(window).scrollTop();
                    var step = Math.round((end - scrollTop) / scrollSpeed);
                    if (scrollTop <= 0 ||
                        scrollTop >= $(window).prop("scrollHeight") - $(window).height() ||
                        goUp && step > -1 ||
                        !goUp && step < 1 ) {
                        clearInterval(interval);
                        interval = null;
                        end = null;
                    }
                    $(window).scrollTop(scrollTop + step );
                }, animationInterval);
            }
        };
    }

    destroyScrollMagic () {
        if(controller == null)
            return;


        controller.destroy(true);
        if(tl != null)
            tl.clear();

        controller = null;
        scene = null;
        tl = null;

        $('.right, .number, h1, p').css("transform", "");
        $('.right, .number, h1, p').css("opacity", "");
    }

    initScrollMagic () {
        var pauze = 1;

        controller = new ScrollMagic.Controller({
            // globalSceneOptions: {
            //     triggerHook: 'onLeave'
            // }
        });


        var t_h01_start = 0;
        var t_h02_start = 1 + pauze;
        var t_h03_start = t_h02_start + 1 + pauze;

        // var contentStartTop = "30%";

        tl = new TimelineMax();
        // .set("#header_01", {zIndex: 3})
        // .set("#header_02", {zIndex: 2});
        // .set("#header_01 .content", {top: contentStartTop});

        tl = this.addSectionAnimation(tl,"#header_01", "#header_02", t_h01_start);


        tl = this.addSectionAnimation(tl,"#header_02", "#header_03", t_h02_start);
        tl = this.addSectionAnimation(tl,"#header_03", "#header_04", t_h03_start);

        // bind to scene
        var $indicators = $('#indicator > span');
        var $indicatorCounter =  $('#indicator--counter');

        var $downButton = $('#scroll_down');
        // create scene to pin and link animation
        new ScrollMagic.Scene({
            triggerElement: "#pinContainer",
            triggerHook: "onLeave",
            duration: "200%"
        })
            .setPin("#pinContainer")
            .setTween(tl)
            .on("progress", function (e) {
                var index;
                if(e.progress < 0.1){
                    index = 0;
                    window.currentStep = 1;
                }else if(e.progress < 0.43){
                    index = 1;
                    window.currentStep = 2;
                }else if(e.progress < 0.75){
                    index = 2;
                    window.currentStep = 3;
                }else{
                    index = 3;
                    window.currentStep = 4;
                }

                $indicators.removeClass('active');
                $indicators.eq(index).addClass('active');
                $indicatorCounter.html('0' + window.currentStep);


            })
            .addTo(controller);


        // new ScrollMagic.Scene({triggerElement: "#collection", offset: 10, triggerHook: "onLeave"})
        //     .setPin("#pin-on-top")
        //     .setClassToggle("#pin-on-top", "transparent") // add class toggle
        //     .addTo(controller);


        // new ScrollMagic.Scene({triggerElement: "#collection", offset: -57, triggerHook: "onLeave",})
        //     .setClassToggle("#logo-dark", "show") // add class toggle
        //     .addTo(controller);
    }

    addSectionAnimation(tl, section_out, section_in, start){
        var sections = [
            '#header_01',
            '#header_02',
            '#header_03',
            '#header_04',
        ];

        var index = sections.indexOf(section_out);
        sections.splice(index, 1);
        index = sections.indexOf(section_in);
        sections.splice(index, 1);


        tl
            .set(sections, {zIndex: 1, opacity: 0})
            // .set("#header_02", {zIndex: 1})
            // .set("#header_03", {zIndex: 1})
            // .set("#header_04", {zIndex: 1})
            .set(section_out, {zIndex: 2, opacity: 1})
            .set(section_in, {zIndex: 3, opacity: 1})


            .to(section_out + " .number", 0.2, {x: -250}, start)
            .to(section_out + " h1", 0.3, {y: -200, opacity: 0}, start + 0.03)
            // .to(section_out + " p", 0.1, {opacity: 0, y: 100}, start + 0.03)
            .to(section_out + " .text", 1,   {x: "-100%"}, start + 0.1)
            .to(section_out + " .img", 0.3,   {x: "120%", ease: Power1.easeIn}, start + 0.2)

            //h3: animate text in
            // .set(section_in, {zIndex: 3}, start + 1.1)
            .fromTo(section_in + " .img", 1, {x: "120%"}, {x: "0%"}, start + 0.2)
            .from(section_in + " .number", 0.2, {x: -250}, start + 0.1)
            .from(section_in + " h1", 0.3, {y: -200, opacity: 0}, start + 0.8)
            .from(section_in + " .text", 0.3, {x: "-100%"}, start + 1.1)
        // .from(section_in + " p", 0.1, {opacity: 0, y: 50}, start + 1.1);


        return tl;
    }

    initScrollMagicMobile () {
        controller = new ScrollMagic.Controller();


        // var slides = document.querySelectorAll(".pane");
        //
        // // create scene for every slide
        // for (var i=0; i<slides.length; i++) {
        //     new ScrollMagic.Scene({
        //         triggerElement: slides[i],
        //         triggerHook: 'onLeave'
        //     })
        //         .setPin(slides[i])
        //        // .addIndicators() // add indicators (requires plugin)
        //         .addTo(controller);
        // }

        var $indicators = $('#indicator span');
        var $indicatorCounter =  $('#indicator--counter');


        new ScrollMagic.Scene({triggerElement: "#pinContainer", offset: 0, triggerHook: "onLeave"})
            .on("update", function (e) {
                var progress =  e.scrollPos / $('#pinContainer').outerHeight();
                console.log(progress);

                var index;
                if(progress < 0.22){
                    index = 0;
                    window.currentStep = 1;
                }else if(progress < 0.45){
                    index = 1;
                    window.currentStep = 2;
                }else if(progress < 0.70){
                    index = 2;
                    window.currentStep = 3;
                }else if(progress < 1){
                    index = 3;
                    window.currentStep = 4;
                    //$("#pinContainer, #indicator, #scroll_down").removeClass('hide');
                }else{
                    //$("#pinContainer, #indicator, #scroll_down").addClass('hide');
                }

                $indicators.removeClass('active');
                $indicators.eq(index).addClass('active');
                $indicatorCounter.html('0' + window.currentStep);
            })
            .addTo(controller);

    }

    initButtons () {
        var self = this;
        $('#scroll_down').click(function (e) {
            // e.preventDefault();

            switch (window.currentStep){
                case 1:
                    self.scrollToStep(2);
                    break;
                case 2:
                    self.scrollToStep(3);
                    break;
                case 3:
                    self.scrollToStep(4);
                    break;
                case 4:
                    self.scrollToStep(5);
                    break;
            }
        });

        $('#indicator span, #view-the-looks').click(function (e) {
            e.preventDefault();

            self.scrollToStep($(e.target).data('step'));
        });
    }

    scrollToStep (step){
        if(window.isAnimating)
            return;


        var scroll;
        var speed = 1.5 * 0.4;
        var stepHeight;
        var stepHeights = [];

        if(window.innerWidth < mobileWidth){
            stepHeight = $(window).height();
            // stepHeights[1] = stepHeight * (1);
            // stepHeights[2] = stepHeight * (3);
            // stepHeights[3] = stepHeight * (5);
            // stepHeights[4] = stepHeight * (7);
            stepHeights[1] = "#header_01";
            stepHeights[2] = "#header_02";
            stepHeights[3] = "#header_03";
            stepHeights[4] = "#header_04";
            stepHeights[5] = "#looks";
        }else{
            stepHeight = $('.scrollmagic-pin-spacer').eq(0).innerHeight();
            stepHeights[1] = stepHeight * (0);
            stepHeights[2] = stepHeight * (0.222222);
            stepHeights[3] = stepHeight * (0.444444);
            stepHeights[4] = stepHeight * (2/3);
            stepHeights[5] = "#looks";

        }

        setAnimating(true);

        scroll = stepHeights[step];
        window.currentStep = step;

        switch (step){
            case 1:
                break;
            case 2:

                break;
            case 3:
                break;
            case 4:
                break;
            case 5:
                speed = 1;
                window.currentStep = 4;
                break;
        }

        TweenMax.to(window, speed, {scrollTo: {y: scroll, autoKill:false}, onComplete: function () {
            setTimeout(function () {
                setAnimating(false);
            }, 1000);
        }});
    }
};
